/*!
 * Copyright (c) 2021 by DCCS GmbH. All rights reserved.
 */

import M from "materialize-css/dist/js/materialize.min.js"
require('./setup/bus');

const appHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', appHeight);

appHeight();

window.Merkur = window.Merkur || {};

if(Liferay && document.body.classList.contains("kundenportal")) {
    import('./initKundenportal.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `KundenPortal`', error));
}

if (document.querySelector('.toggle-navigation')) {
    const $toggleButtons = document.querySelectorAll('.toggle-navigation');
    const $backdrop = document.querySelector('.page-navigation-backdrop');

    $toggleButtons.forEach($toggle => {
        $toggle.addEventListener('click', event => {
            event.preventDefault();
            document.body.classList.toggle('is-navigation-visible');
        });
    });

    $backdrop.addEventListener('click', event => {
        event.preventDefault();
        document.body.classList.remove('is-navigation-visible');
    });

    document.addEventListener('keyup', event => {
        if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
            document.body.classList.remove('is-navigation-visible');
        }
    });
}

if (document.querySelector('.main-navigation')) {
    import(/* webpackChunkName: "navigation" */ './components/navigation/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `navigation`', error));
}


if (document.querySelector('.news-list-categories')) {
    import(/* webpackChunkName: "news" */ './components/news/news-categories.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `news`', error));
}
if (document.querySelector('.filter-list')) {
    import(/* webpackChunkName: "filter-list" */ './components/filter-list/filter-categories.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component', error));
}
if (document.querySelector('#app-search')) {
    import(/* webpackChunkName: "search" */ './components/search/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the search component', error));
}
if (document.querySelector('.main-app')) {
    import(/* webpackChunkName: "svg-fix" */ './components/svg-reference-correction/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `svg-reference-correction`'));
}
if (document.querySelector('.steps-slider')) {
    import(/* webpackChunkName: "steps-slider" */ './components/steps-slider/steps-slider.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `steps-slider`'));
}
if (document.querySelector('#app-consultant')) {
    import(/* webpackChunkName: "app-consultant" */ './components/consultant/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `App Consultant`'));
}
if (document.querySelector('.quote')) {
    import(/* webpackChunkName: "quote" */ './components/quote/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `quote`'));
}
if (document.querySelector('.video')) {
    import('./components/video/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `video`'));
}
if (document.querySelector('.case-studies')) {
    import('./components/case-studies/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `case-studies`'));
}
if (document.querySelector('.merkur-form')) {
    import(/* webpackChunkName: "forms" */ './components/dccs-form/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Form`'));
}
if (document.querySelector('#merkurpartner_detail_container')) {
    import(/* webpackChunkName: "vorsorge" */ './components/partner-programme/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Partner-Programme`'));
}
if (document.querySelector('#app-vorsorgepartner')) {
    import(/* webpackChunkName: "vorsorge" */ './components/vorsorgepartner/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Vorsorgepartner`'));
}
if (document.querySelector('.explanation')) {
    import(/* webpackChunkName: "forms" */ './components/explanation/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Explanation`'));
}
if (document.querySelector('#news-list-kundenportal')) {
    import('./components/news/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `News`'));
}
if (document.querySelector('.text-tabs-grid')) {
    import('./components/text-tabs/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Text Tabs`'));
}
if (document.querySelector('#consultants-search')) {
    import(/* webpackChunkName: "consultant-search" */ './components/consultants-search/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Consultant search`'));
}
if (document.querySelector('#location-search-container')) {
    import(/* webpackChunkName: "location-search" */ './components/location-search/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Location Search`'));
}
if (document.querySelector('#quicksearch')) {
    import('./components/search/quicksearch.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Quick Search`'));
}
if (document.querySelector('#maphq')) {
    import ('./components/maphq/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `MapHQ`'))
}
if (document.querySelector('#consultant-info')) {
    import ('./components/consultant-info/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Consultant-Info`'))
}
if (document.querySelector('.lazy-load-component')) {
    import ('./components/lazy-load/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `Consultant-Info`'))
}
if (document.querySelector('#contest-teaser-container')) {
    import('./components/contest/teaser.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `ContestTeaser Teaser`'));
}
if (document.querySelector('#contest-details-container')) {
    import('./components/contest/details.js')
        .then(module => module.default())
        .catch(error => console.error('An error occured while loading the component `ContestTeaser Details`'));
}
if (document.querySelector('.merkur-popup-wrapper')) {
    import('./components/popup/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `popup-wrapper`', error));

}
if (document.querySelector('.slider-container')) {
    import(/* webpackChunkName: "slider" */ './components/slider/slider.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Slider script!`', error));
}
if (document.querySelector('.slider-container')) {
    import(/* webpackChunkName: "gallery" */ './components/lightbox/lightbox.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Lightbox script!`', error));
}

if (document.querySelector('.card-navigation [href*="/portal/inbox.html"]')) {
    import(/* webpackChunkName: "mailbox" */ './components/mailbox/mailbox.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `Mailbox`', error));
}

if (document.querySelector(".hanse-container")) {
    import(/* webpackChunkName: "hanse-button-redirect" */ './components/hanse-merkur-button/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Hanse Merkur Button script!`', error));
}

if (document.querySelector(".hanse-redirect-to-url")) {
    import(/* webpackChunkName: "hanse-redirect-to-url" */ './components/hanse-merkur-redirect/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Hanse Merkur Redirect script!`', error));
}

if (document.querySelector("div[id*='fragment'] .akkordeon ul.collapsible > div")) {
    import(/* webpackChunkName: "fragment-collapsibles" */ './components/fragment-collapsibles/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Hanse Merkur Redirect script!`', error));
}

if(document.getElementById("app-install-btn")) {
    import(/* webpackChunkName: "smart-banner-android" */ './components/smart-banner/index.js')
        .then(module => {
            module.default();
    })
    .catch(error => console.error('An error occurred while loading the Hanse Merkur Redirect script!`', error));
}

if(document.getElementsByClassName("campaign-popup").length>0) {
    import(/* webpackChunkName: "smart-banner-android" */ './components/campaign-popup/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Hanse Merkur Redirect script!`', error));
}

if(document.getElementsByClassName("product-package").length>0) {
    import(/* webpackChunkName: "product-packages" */ './components/product-packages/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Product Packages script!`', error));
}

/*if(document.getElementById("ego4you-link")) {
    import(
        .then(module => {
            module.default();
    })
    .catch(error => console.error('An error occurred while loading the Hanse Merkur Redirect script!`', error));
}*/

if (document.querySelector("body.kundenportal")) {
    import(/* webpackChunkName: "vermittlernr" */ './components/vermittlernr/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the vermittlerNr script!`', error));
}

// Materialize AutoInit
if(M && AUI) {
    AUI().ready(() => {
        M.AutoInit();
    });
} else {
    setTimeout(() => {
       if(M && AUI) {
           AUI().ready(() => {
               M.AutoInit();
           });
       }
    }, 3000)
}

